import { Trans } from 'react-i18next'

import { Moon24, Sun24 } from '@makyoapp/makyo-icon/icon'
import { ColorVariant } from '@makyoapp/makyo-tw-ui'
import { Field } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useBuilderColorSchemeV2 } from '@/hooks/__project__/useBuilderColorSchemeV2'
import { AccordionItem } from '@/components/Accordion/Accordion'
import { BrandKitColorsDropdown } from '@/components/BrandKitColorsDropdown'

/**
 * StatusbarAccordionItem is a functional component that represents an accordion item in the top bar.
 * It provides an interactive UI item that can be expanded or collapsed to display or hide content.
 */
export default function StatusbarAccordionItem() {
  const { project, statusBarColor, setStatusBarColor, updateProjectStatusBarColor } = useAppBuilderContext()

  const [scheme] = useBuilderColorSchemeV2()
  const mode = scheme.current

  const handleUpdateStatusBar = async (mode: 'light' | 'dark', color: ColorVariant) => {
    if (!project?.id || !color) return

    setStatusBarColor((prev) => {
      prev[mode] = color
      updateProjectStatusBarColor(project.id, prev.light, prev.dark)
      return prev
    })
  }

  return (
    <AccordionItem
      itemId='setting-status-bar'
      title={<Trans>App Status Bar</Trans>}
      righSection={mode === 'dark' ? <Moon24 className='w-3.5 h-3.5' /> : <Sun24 className='w-3.5 h-3.5' />}
    >
      <Field isVertical className='py-0 flex items-center! flex-row! justify-between! min-h-10!'>
        <label className='w-5/12'>
          <Trans>Color {mode === 'dark' ? '(Dark)' : '(Light)'}</Trans>
        </label>
        <BrandKitColorsDropdown
          value={mode === 'dark' ? statusBarColor.dark : statusBarColor.light}
          onChange={(value) => handleUpdateStatusBar(mode, value)}
        />
      </Field>
    </AccordionItem>
  )
}
